export const moduleRoutes = {
  root: 'dashboards',
  childForms: {
    operationDashboard: {
      data: { title: 'Dashboard / reconciliation' },
      requireAuth: false,
      route: 'operationDashboard',
    },
    homeImage: {
      data: { title: 'Inicio' },
      requireAuth: true,
      functions: [],
      route: 'homeImage',
    },
  },
  layout: 'main',
  loadChildren: () => import('src/app/pages/dashboards/dashboards.module').then(m => m.DashboardModule),
};
